import AppDialog from './AppDialog';

type Props = {
  open: boolean;
  onClose: () => void;
  imageUrl: string;
};

function AppImageDialog({open, onClose, imageUrl}: Props) {
  return (
    <AppDialog
      showModel={open}
      onClose={onClose}
      showCloseIcon={true}
      width={1200}
      fullHeight>
      <div className="w-full h-full flex justify-center items-center">
        <img
          src={imageUrl}
          alt="image"
          className="max-w-full max-h-full object-contain"
        />
      </div>
    </AppDialog>
  );
}

export default AppImageDialog;
